import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';

gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.investment-platform-text-with-scheme-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const scheme = query('.scheme');
    const schemeBG = query('.scheme-layout-bg');
    const schemeLine = query('.scheme-decor-line-inner');
    const elementsOdd = queryAll('.scheme-layout-col:nth-child(odd)');
    const elementsEven = queryAll('.scheme-layout-col:nth-child(even)');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: scheme,
            start: 'top 100%',
        },
    });
    if (scheme) transparentBeforeAnimation(scheme, timeline);
    timeline.fromTo(elementsEven, { opacity: '0', y: '-1em', x: '1em', scale: '0' }, {
        opacity: '1', y: '0', x: '0', scale: '1', duration: 0.8, stagger: 0.3, ease: 'ease-in-out',
    }, 'start+=0.2');
    timeline.fromTo(schemeBG, { scale: '0' }, {
        scale: '1', duration: 1.7, stagger: 0.1, ease: 'ease-in-out',
    }, 'start+=1.7');
    timeline.fromTo(schemeLine, { clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)' }, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', duration: 1.9, stagger: 0.1, ease: 'ease-in-out',
    }, 'start+=1.7');
    timeline.fromTo(elementsOdd, { opacity: '0', scale: '0' }, {
        opacity: '1', scale: '1', duration: 0.8, stagger: 0.3, ease: 'ease-in-out',
    }, 'start+=1.2');
};

export { sectionSelector, sectionCallBack };
